// extracted by mini-css-extract-plugin
export default {"container":"detail_container__cFWmD","table":"detail_table__spIUT"};